module.exports = __webpack_public_path__ + "assets/img/znjj_d_s_1.fae492b2.png";